import KatalLogger from '@amzn/katal-logger';

export const logger = new KatalLogger({
  url: 'https://74tfwtmc7l.execute-api.eu-west-1.amazonaws.com/prod/v1/log',
  maxLogLineSize: 10000, // default 5000
});
